import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Table, Alert } from 'antd'
import { getDataOfType } from 'src/lib/utils/get-data-of-type'
import B2BLayout from 'src/react-app/layouts/b2b'
import fetchAPI from 'src/lib/utils/fetch-api'
import { tableRowClick, getColumnsOfSchema, formatListData2 } from 'src/lib/utils/list'
import selectedSchema from './json-schema.json'
import { beforeDataColumns, afterDataColumns } from './utils'
import { filterRoles } from 'src/react-app/pages/card-order/utils'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

function isView(sessionData, roles) {
	const currentRoles = getDataOfType(sessionData, 'roles', Array, [])
  return Boolean(filterRoles(currentRoles, roles).length)
}


const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData
)



export default function AdminObjectsListPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const [dataSource, setDataSource] = useState<any[]>([])
  const [isDataLoading, setIsDataLoading] = useState(true)
  const [dataColumns, setDataColumns] = useState<any[]>([])
  const [pageErrors, setPageErrors] = useState<String[]>([])
  const breadcrumbs = useMemo(() => (
    [{
      href: location.pathname,
      title: 'Отчеты',
    }, {
      href: location.pathname,
      title: 'Список отчетов',
    }]
  ), [location.pathname])

  const { sessionData } = useSelector(createSession)

  // @ts-ignore
  const finalColumns = useMemo(() => [].concat(beforeDataColumns, dataColumns, afterDataColumns).filter(item => item.title), [dataColumns])
  const cbTableRowClick = useCallback(item => navigate(`/report/${getDataOfType(item, 'id', Number, '')}`), [history])

  useEffect(() => {
    const getData = async () => {
      const pageErrors: string[] = []
      const name = 'reports'
      const collections = await fetchAPI(`/api/collections/${name}?access_key=axioma`)
      const collectionData = getDataOfType(collections, 'data.data', Array, null)
      if(collectionData === null) {
        pageErrors.push('Некорректный ответ сервера при получении метаданных коллекции')
        return 
      }
      const filterCollectionData = collectionData.filter(item => isView(sessionData, getDataOfType(item, 'data.attributes.roles', Array, [])) )

      const dataSource: any[] = formatListData2(filterCollectionData, selectedSchema)

      const newDataColumns: any[] = getColumnsOfSchema(selectedSchema)

      setDataColumns(newDataColumns)
      setDataSource(dataSource)
      setPageErrors(pageErrors)
      setIsDataLoading(false)
    }

    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      {(pageErrors.length > 0) ? (
        <div style={{ marginBottom: 40 }}>
          <Alert
            message="При выполнении операции возникла ошибка:"
            showIcon
            type="error"
            description={pageErrors.join('. ')}
            />
        </div>
      ): null}
      <Table
        rowKey="id"
        size="small"
        columns={finalColumns}
        dataSource={dataSource}
        pagination={false}
        loading={isDataLoading}
        onHeaderRow={(column: any) => ({
          style: {
            fontSize: (column.key && column.key.substr(-3) === '-at') ? 9 : 13,
          }
        })}
        onRow={record => ({ onClick: event => tableRowClick(event, record, cbTableRowClick)})}
      />
    </B2BLayout>
  )
}
